import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DialogConfirmSpaceEmailComponent } from '../dialog-confirm-space-email/dialog-confirm-space-email.component';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-dialog-confirm-save-parker',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
  ],
  templateUrl: './dialog-confirm-save-parker.component.html',
  styleUrl: './dialog-confirm-save-parker.component.scss',
})
export class DialogConfirmSaveParkerComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmSpaceEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IEmailChecked,
  ) {}
}

export interface IEmailChecked {
  isAgreementChecked: boolean;
}
